export const ERR_NETWORK = "網路似乎有問題喔～"

export const ERR_PASSWD = "您是忘記密碼了, 還是害怕想起來？～"

export const ERR_EMAIL_ALREADY_EXISTS = "這個 email 已經有人使用囉～"

export const ERR_REGISTER = "此帳號已經存在～"

export const INFO_VERIFY_EMAIL = "確認碼已經寄到您的 email 囉～請到您的 email 取得確認碼～"